module.exports = __webpack_public_path__ + "static/media/img28.358dd747.jpg";